import { ESERVICE_MENU_SAVE, eserviceMenuActions } from '../../components/EServiceFormMenu/eservicemenu.actions';
import {
  SET_FORM_VALUE,
  formModelActions,
  SET_TRANSLATIONS,
  SET_FORM_ID,
  globalActions,
  CLOSE_MESSAGE_BAR,
  SET_CURRENT_STEP,
  FLIP_IS_SENDING_FLAG,
  flipIsSendingFlagAction,
  SET_TOUCHED_MAP,
  setTouchedMapAction,
  SET_IS_SAVING,
} from '../Actions';
import { FormCommonGlobals } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { WizardHostStat } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { PayloadAction } from 'sos-common/js/commonTypes/action.types';

const initialState = {
  orderId: '',
  translations: [],
  purposeForSaveSerialNoOptions: [],
  homePageUrl: '',
  thankYouPageUrl: '',
  shouldShowDelete: false,
  showSavedBanner: false,
  currentStep: 0,
  hasHitSummary: false,
  apiBaseUrl: '',
  isSending: false,
  isSaving: false,
  touchedMap: new Map<any, any>(),
} as FormCommonGlobals;
function setStepState(state: FormCommonGlobals, step: WizardHostStat) {
  const newState = { ...state, currentStep: step.activeStep };
  if (state.hitSummaryStep > 0) {
    if (!newState.hasHitSummary) {
      newState.hasHitSummary = step.activeStep === state.hitSummaryStep;
    }
  } else if (!newState.hasHitSummary) {
    newState.hasHitSummary = step.activeStep === step.totalSteps;
  }
  return newState;
}

function flipIsSendingFlagInState(state: FormCommonGlobals) {
  const newState = { ...state };
  newState.isSending = !newState.isSending;
  return newState;
}

function setTouchedMap(state: FormCommonGlobals, touchedMap: Map<any, any>) {
  const newState = { ...state };
  newState.touchedMap = new Map(state.touchedMap);
  touchedMap.forEach((value: boolean, key: string) => {
    newState.touchedMap.set(key, value);
  });
  return newState;
}

function setIsSaving(state: FormCommonGlobals, value: boolean) {
  if (state.isSaving === value) {
    return state;
  }
  return { ...state, isSaving: value };
}

type validActions =
  | globalActions
  | formModelActions
  | eserviceMenuActions
  | flipIsSendingFlagAction
  | setTouchedMapAction
  | PayloadAction<typeof SET_IS_SAVING, boolean>;

export function globals(state: FormCommonGlobals = initialState, action: validActions) {
  switch (action.type) {
    case SET_TRANSLATIONS:
      return { ...state, translations: action.payload };
    case SET_FORM_ID:
      return { ...state, orderId: action.payload, shouldShowDelete: true };
    case ESERVICE_MENU_SAVE:
      return { ...state, showSavedBanner: true };
    case SET_FORM_VALUE:
      return { ...state, showSavedBanner: false };
    case CLOSE_MESSAGE_BAR:
      return { ...state, showSavedBanner: false };
    case SET_CURRENT_STEP:
      return setStepState(state, action.payload);
    case FLIP_IS_SENDING_FLAG:
      return flipIsSendingFlagInState(state);
    case SET_TOUCHED_MAP:
      return setTouchedMap(state, action.payload);
    case SET_IS_SAVING:
      return setIsSaving(state, action.payload);
    default:
      return state;
  }
}
